import { motion } from 'motion/react';
import { Wrench, X } from 'lucide-react';

interface MaintenanceModeProps {
  onExit: () => void;
}

export default function MaintenanceMode({ onExit }: MaintenanceModeProps) {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className="min-h-screen bg-zinc-700 flex items-center justify-center p-4"
    >
      <div className="max-w-md w-full text-center">
        <motion.div
          initial={{ scale: 0.8, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ delay: 0.2 }}
          className="backdrop-blur-xl bg-white/10 rounded-3xl p-8 border border-white/20"
        >
          <div className="w-16 h-16 mx-auto mb-6 bg-white/20 rounded-full flex items-center justify-center">
            <Wrench className="w-8 h-8 text-white" />
          </div>
          
          <h1 className="text-2xl font-medium text-white mb-4">
            Under Maintenance 
          </h1>
          
          <p className="text-white/80 mb-8 leading-relaxed">
            I'm currently updating the site to bring you a better experience. 
            Please check back soon!
          </p>
          
              <div className="grid md:grid-cols-1 text-start">
                {/* WhatsApp */}
                <a
                  href="https://wa.me/+8801717959838"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block bg-gradient-to-br from-green-50 to-green-100 dark:from-green-900/20 dark:to-green-800/20 border border-green-200 dark:border-green-700 rounded-2xl p-6 hover:shadow-lg hover:shadow-green-500/20 transition-all duration-300 group hover:-translate-y-1"
                >
                  <div className="flex items-start space-x-4">
                    <div className="w-14 h-14 bg-green-500 rounded-xl flex items-center justify-center group-hover:bg-green-600 transition-colors">
                      <svg className="w-7 h-7 text-white" fill="currentColor" viewBox="0 0 24 24">
                        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.885 3.700"/>
                      </svg>
                    </div>
                    
                    <div className="flex-1">
                      <h3 className="font-medium text-green-900 dark:text-green-100 mb-1">WhatsApp</h3>
                      <p className="text-sm text-green-800 dark:text-green-400">
                        Quick response, perfect for urgent questions
                      </p>
                    </div>
                  </div>
                </a>
              </div>

        </motion.div>
      </div>
    </motion.div>
  );
}
